import React from 'react';
import { Badge, Button, Icon } from 'antd';
import { Text4, Text5 } from '../../../styles';
import { PAYOUT_LINK_STATUS_TYPES } from '../../../constants';
import { printRupee } from '../../../app_methods';
import moment from 'moment';


export const getPayoutLinksTableColumns = (methods) => [{
    title: "Payee",
    key: "payee",
    width: "30%",
    render: (record) => <div>
        <Text4 className="d-block">{record.payee_name}</Text4>
        <Text5 className="d-block">{record.payee_phone || record.payee_email}</Text5>
    </div>
}, {
    title: "Amount",
    key: "amount",
    render: (record) => <Text4>{printRupee(record.amount)}</Text4>
}, {
    title: "Link",
    key: "link",
    render: (record) => <Text4 copyable>{record.link}</Text4>
}, {
    title: <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}><span>Status</span><Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" /></span>,
    key: "status",
    render: (record) =>
        <div>
            <Badge color={PAYOUT_LINK_STATUS_TYPES[record.status].color} text={<Text4>{PAYOUT_LINK_STATUS_TYPES[record.status].label}</Text4>} />
        </div>
}, {
    title: "Actions",
    render: (record) => <>
        <Button className="mr-1" size="small" onClick={() => methods.togglePayoutLinkDetailsDrawer(record)}>Details</Button>
    </>
}];

export const payoutLinksFilterNodes = [{
    label: "Created At",
    field: "created_at",
    placeholder: "Select Creation Date",
    inputType: "date_range",
    defaultValue: [moment().startOf("month"), moment().endOf("month")],
    disabledDate: moment().subtract(3, "months"),
    preventClear: true,
}, {
    label: "Payee Name",
    field: "payee_name",
    placeholder: "Enter Name",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Payee Email",
    field: "payee_email",
    placeholder: "Enter Email ID",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Payee Phone",
    field: "payee_phone",
    placeholder: "Enter Phone Number",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Status",
    field: "status",
    placeholder: "Select Status",
    inputType: "select",
    defaultValue: undefined,
    options: Object.keys(PAYOUT_LINK_STATUS_TYPES).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = type;
        object.label = <Badge color={PAYOUT_LINK_STATUS_TYPES[type].color} text={<Text4>{PAYOUT_LINK_STATUS_TYPES[type].label}</Text4>} />;
        return object;
    })
}];

// export const payoutLinksFilterNodes = (current_user) => {

//     let nodes = [{
//         label: "Created At",
//         field: "created_at",
//         placeholder: "Select Creation Date",
//         inputType: "date_range",
//         defaultValue: [moment().startOf("month"), moment().endOf("month")]
//     }, {
//         label: "Payee Name",
//         field: "payee_name",
//         placeholder: "Enter Name",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Payee Email",
//         field: "payee_email",
//         placeholder: "Enter Email ID",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Payee Phone",
//         field: "payee_phone",
//         placeholder: "Enter Phone Number",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Status",
//         field: "status",
//         placeholder: "Select Status",
//         inputType: "select",
//         defaultValue: undefined,
//         options: Object.keys(PAYOUT_LINK_STATUS_TYPES).map((type, index) => {
//             let object = {};
//             object.key = index;
//             object.value = type;
//             object.label = <Badge color={PAYOUT_LINK_STATUS_TYPES[type].color} text={<Text4>{PAYOUT_LINK_STATUS_TYPES[type].label}</Text4>} />;
//             return object;
//         })
//     }];
//    if (current_user.is_reseller && current_user.esda){
//         nodes.unshift({
//             label: "Merchant",
//             field: "submerchant_id",
//             placeholder: "Merchant ID",
//             width: 250,
//             inputType: "select",
//             showSearch: true,
//             defaultValue: undefined,
//             options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
//                 let object = {};
//                 object.key = index;
//                 object.value = sub_merchant.id;
//                 object.label = sub_merchant.name+" ("+sub_merchant.email+")"
//                 return object;
//             }): []

//         })
//     }
//     return nodes
// }